module.exports = __webpack_public_path__ + "static/img/yuanmou_zhongyi_yuanbiao.30cad936.png";